/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-12 14:20:50
 *
 *******************************************************/
//@flow
import React from 'react';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';
import { ReactComponent as IconCheck } from 'src/assets/images/shopify-integration-settings/check.svg';

export const RenderRadioButton2 = (field: Object) => {
  const isDisabled = Boolean(field.disabled);
  const invisible = Boolean(field.invisible);
  const radioButtonClass = classnames('radio-button-2', {
    disabled: isDisabled
  });
  const labelClass = classnames('Polaris-Button', {
    checked: field.input.value === field.id,
    'full-size': field.fullSize
  });
  const tooltip = field?.tooltip;
  const isShowIconCheck = field.isShowIconCheck;

  return tooltip ? (
    <div className={radioButtonClass} data-tip={tooltip} data-for={`radio-${field.id}`}>
      <label htmlFor={`${field.input.name}_${field.id}`} className={labelClass}>
        {isShowIconCheck && field.input.value === field.id && <IconCheck className="icon-check" />}
        <span
          className="Polaris-Button__Content"
          style={{ visibility: isDisabled && invisible ? 'hidden' : 'visible' }}>
          <span className="Polaris-Button__Text">{field.label}</span>
        </span>
        <input
          type="radio"
          id={`${field.input.name}_${field.id}`}
          name={field.input.name}
          value={field.id}
          checked={field.input.value === field.id}
          onChange={(e: any) => {
            field.input.onChange(e.target.value);
          }}
          disabled={isDisabled}
        />
      </label>
      <ReactTooltip id={`radio-${field.id}`} place="top" effect="solid" type="light" />
    </div>
  ) : (
    <div className={radioButtonClass}>
      <label htmlFor={`${field.input.name}_${field.id}`} className={labelClass}>
        {isShowIconCheck && field.input.value === field.id && <IconCheck className="icon-check" />}
        <span
          className="Polaris-Button__Content"
          style={{ visibility: isDisabled && invisible ? 'hidden' : 'visible' }}>
          <span className="Polaris-Button__Text">{field.label}</span>
        </span>
        <input
          type="radio"
          id={`${field.input.name}_${field.id}`}
          name={field.input.name}
          value={field.id}
          checked={field.input.value === field.id}
          onChange={(e: any) => {
            field.input.onChange(e.target.value);
          }}
          disabled={isDisabled}
        />
      </label>
    </div>
  );
};
